import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import 'gantt-task-react/dist/index.css';
import useNonceStyle from '@/utils/useNonceStyle';
const styles = {
    table: '_3_ygE',
    header: '_1nBOt',
    item: '_WuQ0f',
    separator: '_2eZzQ'
};
const TaskListHeaderFr = ({ headerHeight, rowWidth, fontFamily, fontSize }) => {
    const fontClass = useNonceStyle({ fontFamily, fontSize });
    const headerClass = useNonceStyle({ height: headerHeight - 2 });
    const itemWidthClass = useNonceStyle({ minWidth: rowWidth });
    const separatorClass1 = useNonceStyle({ height: headerHeight * 0.5, marginTop: headerHeight * 0.2 });
    const separatorClass2 = useNonceStyle({ height: headerHeight * 0.5, marginTop: headerHeight * 0.25 });
    return (_jsx("div", { className: `${styles.table} ${fontClass}`, children: _jsxs("div", { className: `${styles.header} ${headerClass}`, children: [_jsx("div", { className: `${styles.item} ${itemWidthClass}`, children: "\u00A0T\u00E2che" }), _jsx("div", { className: `${styles.separator} ${separatorClass1}` }), _jsx("div", { className: `${styles.item} ${itemWidthClass}`, children: "\u00A0D\u00E9but" }), _jsx("div", { className: `${styles.separator} ${separatorClass2}` }), _jsx("div", { className: `${styles.item} ${itemWidthClass}`, children: "\u00A0Fin" })] }) }));
};
export default TaskListHeaderFr;
